import * as React from 'react'
import type { Base_IContext } from './Base.IContext'
import { Base_Component } from './Base.ui.Component'

export class Base_Inject extends React.Component<Partial<Base_IContext>, {}> {
    public static childContextTypes = Base_Component.contextTypes

    public getChildContext(): Base_IContext {
        return {
            ...this.context,
            data: this.props.data,
            dataSubscribe: this.props.dataSubscribe,
            dataUnsubscribe: this.props.dataUnsubscribe,
            operations: this.props.operations,
        }
    }

    public render() {
        return React.Children.only(this.props.children)
    }
}
